import React, { memo, useState, useCallback, useMemo, forwardRef } from "react";
import { MdShoppingCart } from "react-icons/md";
import { BiChevronDown } from "react-icons/bi";
import useTrack, { eventTypes } from "../../hooks/useTrack";
import { MODES } from "../../conf";
import useData from "../../hooks/useData";
import message from "../../utils/message";
import { MESSAGE_TYPES } from "../../hooks/useMessage";

import "./banner.css";
import useMode from "../../hooks/useMode";
import useExperience from "../../hooks/useExperience";
import usePing, { PING_TYPES } from "../../hooks/usePing";

const Banner = memo(
	forwardRef((_, ref) => {
		const [fired, setFired] = useState(false);
		const track = useTrack();
		const { mode } = useMode();

		const {
			scrapedInformation = false,
			publisher_details: {
				name = "",
				logo_url = "",
				banner_url = "",
			} = {},
		} = useData();

		const { cost } = useMemo(
			() => scrapedInformation || {},
			[scrapedInformation]
		);

		const primaryBgUrl = useMemo(() => banner_url, [banner_url]);

		const logoUrl = useMemo(() => logo_url, [logo_url]);

		const handleMinimize = useCallback(() => {
			if (mode === MODES.MODAL) {
				message(MESSAGE_TYPES.CLOSE_MODAL);
			} else {
				message(MESSAGE_TYPES.MODE_INLINE);
			}
			if (!fired) {
				track(eventTypes.SHOW_ORDER_CLICK);
				setFired(true);
			}
		}, [fired, track, mode]);

		usePing({ key: PING_TYPES.SHOW_ORDER_CLICK, callback: handleMinimize });

		const { shouldIncreaseImpressions } = useExperience();

		return (
			<>
				<section
					className="banner banner-primary"
					style={{
						backgroundImage: `url(${primaryBgUrl})`,
					}}
				>
					<img
						src={logoUrl}
						alt="brand-logo"
						className="banner-brand-logo banner-brand-logo-primary"
					/>
				</section>
				{shouldIncreaseImpressions && <section ref={ref} />}
				{!shouldIncreaseImpressions && (
					<>
						<section className="banner banner-secondary">
							<div className="banner-brand-detail-container">
								<div className="banner-brand-name">{name}</div>
							</div>
						</section>
						<section
							className="banner banner-order-details"
							ref={ref}
						>
							<div
								className="banner-order-details-btn"
								onClick={handleMinimize}
							>
								<MdShoppingCart />
								<span>Show Order Details</span>
								<BiChevronDown />
							</div>
							{cost && (
								<div className="banner-order-details-price">
									{cost}
								</div>
							)}
						</section>
					</>
				)}
			</>
		);
	})
);

export default Banner;
